// bing map init devTools
export default {
    init: function () {
        const bingUesrKey = 'AoeitK0nEz_FlOoSXuMBCn34kvrcL4qpD3zUmgqQmrb4MYlolQWIUaQ6rnKWi-tS';
        const BingMap_URL = 'http://www.bing.com/api/maps/mapcontrol?callback=GetMap&key=' + bingUesrKey;
        return new Promise((resolve, reject) => {
            if (typeof window.Microsoft !== "undefined") {
                resolve(Microsoft);
                return true;
            }

            // 插入script脚本
            let scriptNode = document.createElement("script");
            scriptNode.setAttribute("type", "text/javascript");
            scriptNode.setAttribute("src", BingMap_URL);
            document.body.appendChild(scriptNode);

            // 等待页面加载完毕回调
            let timeout = 0;
            let interval = setInterval(() => {
                if (timeout >= 20) {
                    reject();
                    clearInterval(interval);
                }
                if (typeof window.Microsoft !== "undefined") {
                    resolve(window.Microsoft);
                    clearInterval(interval);
                }
                timeout += 1;
            }, 500);
        });
    }
}
